import { Drawer } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Options } from "../gamemodes/Options";

export default function SingleGame({gamemode}) {
    const [options, setOptions] = useState(false)

    const toggleOptions = (open) => () =>{
        setOptions(open)
        console.log('options')
    }
    
    return (
        <div className="center">
            <div className="overlay-game overlay"></div>
            <div className="block-video">
                <Link to={`/single/${gamemode}/play`}><img src="/play_circle.svg" alt="Play" className='player-icon'/></Link>
            </div>

            <h2 className="clickable" onClick={toggleOptions(true)}>Game Options</h2>
            <Drawer open={options} anchor="right" onClose={toggleOptions(false)}>
                {<Options toggleOptions={toggleOptions()} gamemode={gamemode}></Options>}
            </Drawer>
        </div>
    )
}